import angular from 'angular';
import './icon.styles.scss';

export const IconComponent = {
  selector: 'abIcons',
  restrict: 'E',
  bindings: {
    icon: '@',
  },
  template: /* html */ `
    <div class="icons">
      <!-- Checkboxes -->
      <i data-fa-symbol="checkbox-unchecked" class="fa-light fa-square"></i>
      <i data-fa-symbol="checkbox-checked" class="fa-solid fa-check-square"></i>
      <i data-fa-symbol="radio-unchecked" class="fa-regular fa-circle"></i>
      <i data-fa-symbol="radio-checked" class="fa-solid fa-circle-dot"></i>

      <!-- Button Icons -->
      <i data-fa-symbol="btn-edit" class="fa-solid fa-pen"></i>
      <i data-fa-symbol="btn-copy" class="fa-solid fa-copy"></i>
      <i data-fa-symbol="btn-filter" class="fa-duotone fa-filters"></i>
      <i data-fa-symbol="btn-delete" class="fa-regular fa-trash-can"></i>
      <i data-fa-symbol="btn-add" class="fa-solid fa-plus"></i>
      <i data-fa-symbol="btn-add-cirlce" class="fa-solid fa-circle-plus"></i>
      <i data-fa-symbol="btn-remove-cirlce" class="fa-solid fa-circle-minus"></i>
      <i data-fa-symbol="btn-excel" class="fa-solid fa-file-excel"></i>
      <i data-fa-symbol="btn-times" class="fa-solid fa-times-circle"></i>
      <i data-fa-symbol="btn-times-default" class="fa-regular fa-times"></i>
      <i data-fa-symbol="btn-download" class="fa-regular fa-download"></i>

      <!-- Vehicles -->
      <i data-fa-symbol="vehicle" class="fa-solid fa-car"></i>
      <i data-fa-symbol="vehicles-many" class="fa-solid fa-cars"></i>
      <i data-fa-symbol="vehicle-garage" class="fa-solid fa-garage-car"></i>

      <!-- Misc -->
      <i data-fa-symbol="gas-pump" class="fa-solid fa-gas-pump"></i>
      <i data-fa-symbol="question" class="fa-solid fa-question-circle"></i>
      <i data-fa-symbol="check" class="fa-solid fa-check"></i>
      <i data-fa-symbol="list-item" class="fa-duotone fa-circle-dot"></i>
      <i data-fa-symbol="check-cirlce" class="fa-solid fa-circle-check"></i>
      <i data-fa-symbol="error" class="fa-solid fa-exclamation-triangle"></i>
      <i data-fa-symbol="info" class="fa-solid fa-circle-info"></i>
      <i data-fa-symbol="info-light" class="fa-light fa-circle-info"></i>
      <i data-fa-symbol="list" class="fa-solid fa-square-list"></i>
      <i data-fa-symbol="currency" class="fa-solid fa-euro-sign"></i>
      <i data-fa-symbol="speech-bubbles" class="fa-solid fa-comments"></i>
      <i data-fa-symbol="history" class="fa-solid fa-history"></i>
      <i data-fa-symbol="lock" class="fa-solid fa-lock"></i>
      <i data-fa-symbol="settings" class="fa-solid fa-cog"></i>
      <i data-fa-symbol="calendar" class="fa-solid fa-calendar-days"></i>
      <i data-fa-symbol="circle" class="fa-solid fa-circle"></i>
      <i data-fa-symbol="shield-exclamation" class="fa-solid fa-shield-exclamation"></i>
      <i data-fa-symbol="shield-check" class="fa-solid fa-shield-check"></i>
      <i data-fa-symbol="smiley" class="fal fa-smile-beam"></i>

      <!-- User -->
      <i data-fa-symbol="user-tag" class="fa-solid fa-user-tag"></i>
      <i data-fa-symbol="user" class="fa-solid fa-user"></i>

      <!-- Files -->
      <i data-fa-symbol="folders" class="fa-solid fa-folders"></i>
      <i data-fa-symbol="folder-open" class="fa-solid fa-folder-open"></i>
      <i data-fa-symbol="file" class="fal fa-file"></i>

      <!-- Arrows -->
      <i data-fa-symbol="arrow-down" class="fa-solid fa-chevron-down"></i>
      <i data-fa-symbol="arrow-up" class="fa-solid fa-chevron-up"></i>
      <i data-fa-symbol="arrow-right" class="fa-solid fa-chevron-right"></i>
      <i data-fa-symbol="arrow-left" class="fa-solid fa-chevron-left"></i>
    </div>
  `,
};

export default angular.module('components.icons', [])
  .component(IconComponent.selector, IconComponent)
  .name;
